/* Taken verbatim from themes/neropos/design/home-wow/v3.html (the home v3), so the product page draws the same
   swirl with the same engine. Regenerate with the pages assets script after every change there. */
/* The pack's swirl, version 12: every wave and drop is one and the same drop, the master drop (half width
   R sin(pi/2 s) from the tail tip, s 0, to the head's centre, s 1, closed by a half circle in front); only its size,
   length, bend and colours change. Drawn on a canvas, each piece moving like water.
   NeroSwirl12(data, opt) -> engine. data = window.NEROPOS_SWIRL3 (perfect.mjs + prep3.mjs): drops (t w: the spine every
   4th unit, R, a colour field; the halves of a leaf, shades with the wave they ride, small ones that bob as one) and
   circles (bubble u, glint g on a bubble, speck s on a drop), in drawing order. opt.bg: the colour (fill) of the drop
   that comes at the screen and becomes the background. Everything is in the swirl's own units (1024 x 1024, centre
   512 512).
   It runs on the page's clock t (seconds) and is told what to do: enter(t) and leave(t, withBg). Each piece follows
   from that on its own, so the scroll can turn it round at any moment and every drop still moves head first.
   The way in: each drop flies head first along a lane of its own and keeps its exact shape all the way: its spine
   lies along the lane, so it bends with it, and its widths never change. A lane goes back from the drop's tail on the
   drop's own bend and onto a spiral round the centre that leaves the screen (a drop that points out from the middle
   comes from behind the box), so each drop starts just out of sight and shows from the first frame. It comes fast,
   slows as it lands, sloshes a little and stays. A shade rides the wave it lies under, a speck the drop it sits on, a
   glint its bubble; bubbles rise from below. Lower layers come first, small drops and highlights last, the two halves
   of a leaf meet head to head at the same moment; all in about 3 seconds.
   At rest a slow current moves the waves (along their spines, so their widths never change), while small drops,
   bubbles and dots bob each on its own; the scroll's jolt, the pointer and taps stir the water.
   The way out is the way in turned round in time and played forward: each drop leaves head first on along its lane,
   slow at first and faster as it goes, until it is past the screen's edge; small drops and highlights first, the
   lower layers last; bubbles rise on out at the top. A drop still flying in flies on through its place and out; one
   that had not started stays away. With withBg one drop (opt.bg) comes at the screen instead, in 3D: it sets off
   head first as it heads, curves round over the box and flies at the eye, seen in perspective (its head, nearer,
   grows much faster than its tail, which trails back into the depth), wobbling a little like water, a glint of its
   own on its head, until its head covers the screen and its colour is the background. Told to come in again, it
   turns and flies back head first, smaller and smaller, and lands in its place along its lane as at the way in;
   every piece that left comes in again as at the start (one still on its way out goes on out first). */
(function () {
  var C = 512, RD = Math.PI / 180, TAU = Math.PI * 2, SK = 2.4, PB = 58 * RD;
  // the drop that comes at the screen: its flight at the eye (TC s) and back to its place (TB s), landing LBK units
  // behind its tail on its lane; its glint's colour (the swirl's own lightest)
  var TC = 2.2, TB = 1.5, LBK = 70, GLINT = '#bbefff';
  // on its way at the screen its tail goes where its head was TL s before, so it stretches as it speeds up and its tail
  // trails back towards the swirl; it comes nearer in even steps of log depth over w^PZ of its way (late: it stays a
  // drop a while before it swells over the screen)
  var TL = .8, PZ = 3;
  function cl(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ss(v, a, b) { var x = cl((v - a) / (b - a)); return x * x * (3 - 2 * x); }
  function sm5(q) { q = cl(q); return q * q * q * (10 - 15 * q + 6 * q * q); }
  // the way in: fast from the first frame, slowing as it lands; it still moves a little there (VEND lane lengths per
  // flight) and sloshes on from that
  var EK = 2.6, EA = .72, EC = 1 - Math.pow(1 - EA, EK), VEND = EK * EA * Math.pow(1 - EA, EK - 1) / EC;
  function ein(x) { x = cl(x); return (1 - Math.pow(1 - EA * x, EK)) / EC; }
  function evel(x) { x = cl(x); return EK * EA * Math.pow(1 - EA * x, EK - 1) / EC; }
  // the way out: the way in turned round, slow from where it rests and faster and faster; past its end on at that speed
  var VOUT = evel(0);
  function eout(x) { return x <= 0 ? 0 : x < 1 ? 1 - ein(1 - x) : 1 + VOUT * (x - 1); }
  function slosh(t, v0, w, z) { if (t <= 0) return 0; var wd = w * Math.sqrt(1 - z * z); return v0 / wd * Math.exp(-z * w * t) * Math.sin(wd * t); }
  function wob(t, a, b, p) { return .65 * Math.sin(TAU * t / a + p) + .35 * Math.sin(TAU * t / b + 1.7 * p); }
  function rnd(i) { var x = Math.sin(i * 127.1 + 311.7) * 43758.5453; return x - Math.floor(x); }
  function hex(c) { var v = parseInt(c.slice(1), 16); return [v >> 16, (v >> 8) & 255, v & 255]; }
  function mixc(a, b, f) { var x = hex(a), y = hex(b); return 'rgb(' + Math.round(x[0] + (y[0] - x[0]) * f) + ',' + Math.round(x[1] + (y[1] - x[1]) * f) + ',' + Math.round(x[2] + (y[2] - x[2]) * f) + ')'; }
  // a track: a polyline with its running length
  function track(pts) {
    var q = [pts[0]];
    for (var i = 1; i < pts.length; i++) { var a = q[q.length - 1]; if (Math.abs(pts[i][0] - a[0]) + Math.abs(pts[i][1] - a[1]) > 1e-6) q.push(pts[i]); }
    var n = q.length, X = new Float64Array(n), Y = new Float64Array(n), S = new Float64Array(n);
    for (i = 0; i < n; i++) { X[i] = q[i][0]; Y[i] = q[i][1]; if (i) S[i] = S[i - 1] + Math.hypot(X[i] - X[i - 1], Y[i] - Y[i - 1]); }
    return { X: X, Y: Y, S: S, n: n, len: S[n - 1] };
  }
  // the point at distance d along a track (past either end it carries on straight)
  function pos(T, d, o, j) {
    var X = T.X, Y = T.Y, S = T.S, n = T.n, lo, hi;
    if (d <= 0) { lo = 0; hi = 1; } else if (d >= T.len) { lo = n - 2; hi = n - 1; }
    else { lo = 0; hi = n - 1; while (hi - lo > 1) { var m = (lo + hi) >> 1; if (S[m] <= d) lo = m; else hi = m; } }
    var f = (d - S[lo]) / (S[hi] - S[lo]); o[j] = X[lo] + (X[hi] - X[lo]) * f; o[j + 1] = Y[lo] + (Y[hi] - Y[lo]) * f;
  }
  // ... and its direction there, smoothed over a few units so a frame turns smoothly from one segment to the next
  var FT = [0, 0, 0, 0];
  function at(T, d, o) {
    pos(T, d, o, 0); pos(T, d - 4, FT, 0); pos(T, d + 4, FT, 2);
    var dx = FT[2] - FT[0], dy = FT[3] - FT[1], l = Math.hypot(dx, dy) || 1; o[2] = dx / l; o[3] = dy / l; return o;
  }
  // a spine kept every 4th unit, every unit again (Catmull-Rom through the kept points)
  function dense(sp) {
    var n = sp.length, out = [];
    for (var i = 0; i < n - 1; i++) {
      var p0 = sp[Math.max(0, i - 1)], p1 = sp[i], p2 = sp[i + 1], p3 = sp[Math.min(n - 1, i + 2)], m = Math.max(1, Math.round(Math.hypot(p2[0] - p1[0], p2[1] - p1[1])));
      for (var k = 0; k < m; k++) {
        var t = k / m, t2 = t * t, t3 = t2 * t, q = [0, 0];
        for (var j = 0; j < 2; j++) q[j] = .5 * (2 * p1[j] + (-p0[j] + p2[j]) * t + (2 * p0[j] - 5 * p1[j] + 4 * p2[j] - p3[j]) * t2 + (-p0[j] + 3 * p1[j] - 3 * p2[j] + p3[j]) * t3);
        out.push(q);
      }
    }
    out.push([sp[n - 1][0], sp[n - 1][1]]);
    return out;
  }
  // the slow current at rest: three soft waves across the swirl and a surge round it, one field for every wave
  var CUR = [[1.3, .5, 7.3, .4], [-.6, 1.4, 5.9, 2.1], [.9, -1.1, 9.1, 4.2]];
  function current(x, y, t, out) {
    var dx = 0, dy = 0;
    for (var q = 0; q < 3; q++) { var c = CUR[q], kl = Math.hypot(c[0], c[1]), s = Math.sin(TAU * (c[0] * x / 1024 + c[1] * y / 1024 + t / c[2]) + c[3]); dx -= c[1] / kl * s; dy += c[0] / kl * s; }
    var rx = x - C, ry = y - C, r = Math.hypot(rx, ry) || 1, f = 5 * Math.sin(TAU * t / 6.3 + 2 * Math.atan2(ry, rx) + r / 150);
    out[0] = 4.5 * dx - ry / r * f; out[1] = 4.5 * dy + rx / r * f; return out;
  }
  // its pitch where a way at P heads dx dy: its angle to the circle round the centre there, outwards positive
  function pitchOf(P, dx, dy) {
    var rx = P[0] - C, ry = P[1] - C, rl = Math.hypot(rx, ry) || 1;
    return Math.atan2((dx * rx + dy * ry) / rl, Math.abs(dx * -ry + dy * rx) / rl);
  }
  // a way on from P (unit heading dx dy), a point a unit: at first on its own bend k0 (per unit), and over Sw onto a
  // spiral round the centre (in the sense it heads) whose pitch goes from its own to pT over Sr, and on to PF past
  // the swirl's rim, so it leaves the screen soon (pT null: straight on); until stop(x, y) says so or n points
  var PF = 80 * RD;
  function wayOn(P, dx, dy, k0, pT, Sr, Sw, n, stop) {
    var rx = P[0] - C, ry = P[1] - C, sg = dx * -ry + dy * rx >= 0 ? 1 : -1, p0 = pitchOf(P, dx, dy), h0 = Math.atan2(dy, dx);
    var ax = P[0], ay = P[1], bx = P[0], by = P[1], out = [];
    for (var i = 1; i <= n; i++) {
      var ha = h0 + k0 * (i - .5); ax += Math.cos(ha); ay += Math.sin(ha);
      if (pT === null) { bx += dx; by += dy; }
      else {
        var qx = bx - C, qy = by - C, ql = Math.hypot(qx, qy) || 1, ux = qx / ql, uy = qy / ql, pt = pT + (Math.max(pT, PF) - pT) * ss(ql, 520, 760), p = p0 + (pt - p0) * ss(i, 0, Sr);
        bx += Math.cos(p) * -uy * sg + Math.sin(p) * ux; by += Math.cos(p) * ux * sg + Math.sin(p) * uy;
      }
      var w = sm5(i / Sw), x = ax + (bx - ax) * w, y = ay + (by - ay) * w; out.push([x, y]);
      if (stop && stop(x, y)) break;
    }
    return out;
  }
  // a spine's bend near one end (per unit, signed as its heading turns going towards the head), over up to 40 units
  function bendAt(Dn, fromHead) {
    var n = Dn.length, k = Math.min(n - 1, 40), a, b, c, d;
    if (fromHead) { a = Dn[n - 1 - k]; b = Dn[n - 1 - k + 1]; c = Dn[n - 2]; d = Dn[n - 1]; }
    else { a = Dn[0]; b = Dn[1]; c = Dn[k - 1]; d = Dn[k]; }
    var h1 = Math.atan2(b[1] - a[1], b[0] - a[0]), h2 = Math.atan2(d[1] - c[1], d[0] - c[0]), dh = Math.atan2(Math.sin(h2 - h1), Math.cos(h2 - h1));
    return k > 2 ? dh / (k - 1) : 0;
  }

  window.NeroSwirl12 = function (D, opt) {
    opt = opt || {};
    var E = { pieces: [], T: 0, gr: 0, gz: 0, bg: null, fl: null, gl: null, DZ: 1500, want: '', tIn: 0, farIn: false, mov: false }, F = [0, 0, 0, 0], P = E.pieces;
    // ---------- the pieces, once ----------
    D.pieces.forEach(function (q, k) {
      var o = { i: k, t: q.t, q: q, jx: 0, jy: 0, jv: 0, jvx: 0, ramp: 0, vis: false, tf: null, alpha: 1, mode: 'off' };
      if (q.t === 'w') {
        var Dn = dense(q.sp), Sd = [0];
        for (var j = 1; j < Dn.length; j++) Sd.push(Sd[j - 1] + Math.hypot(Dn[j][0] - Dn[j - 1][0], Dn[j][1] - Dn[j - 1][1]));
        o.Dn = Dn; o.L = Sd[Sd.length - 1]; o.R = q.R;
        // the drop that comes at the screen is drawn very big at the end, so it has many more points
        var big = !E.bg && !!opt.bg && q.fill === opt.bg && !q.shade && !q.leaf && q.host === undefined;
        // NB points along it (evenly by length), its half width at each; the half circle in front in NC steps
        var nb = big ? 160 : Math.max(12, Math.min(240, Math.round(o.L / 5) + 1)), nc = big ? 120 : Math.max(10, Math.min(48, Math.round(Math.PI * q.R / 2.5)));
        o.nb = nb; o.nc = nc; o.s = new Float64Array(nb); o.W = new Float64Array(nb);
        for (j = 0; j < nb; j++) { o.s[j] = j / (nb - 1); o.W[j] = q.R * Math.sin(Math.PI / 2 * o.s[j]); }
        o.SPX = new Float64Array(nb); o.SPY = new Float64Array(nb); o.OX = new Float64Array(2 * nb + nc - 2); o.OY = new Float64Array(2 * nb + nc - 2);
        o.GX = new Float64Array(2); o.GY = new Float64Array(2);
        o.k0 = bendAt(Dn, false); o.k1 = bendAt(Dn, true);
        var mid = Dn[Math.floor(Dn.length / 2)]; o.mx = mid[0]; o.my = mid[1];
        if (big) E.bg = o;
      } else {
        o.c = q.c; o.r = q.r; o.area = Math.PI * q.r * q.r;
        // the circle's centre and the two ends of its colour field, as the points it moves
        o.x = [q.c[0]]; o.y = [q.c[1]];
        if (q.grad) { o.x.push(q.grad.p0[0], q.grad.p1[0]); o.y.push(q.grad.p0[1], q.grad.p1[1]); }
        o.X = o.x.slice(); o.Y = o.y.slice();
      }
      P.push(o);
    });
    // who rides whom: a shade its wave, a speck its drop (the lane it moves on is its base's: a speck on a shade that
    // rides a wave rides that wave's lane), a glint its bubble
    P.forEach(function (o) {
      var q = o.q;
      if (q.host === undefined) return;
      var h = P[q.host]; o.host = h;
      if (o.t === 'w' || o.t === 's') o.base = h.t === 'w' ? (h.q.host !== undefined && P[h.q.host].t === 'w' ? P[h.q.host] : h) : null;
    });
    P.forEach(function (o) { if (o.base) (o.base.riders = o.base.riders || []).push(o); });
    // the pieces that move on their own: the drops that ride nothing, and the bubbles (the rest ride them)
    var OWN = P.filter(function (o) { return (o.t === 'w' && !o.base) || o.t === 'u'; }), DROPS = OWN.filter(function (o) { return o.t === 'w'; });

    // ---------- the lanes, for the screen V and the box B (both in the swirl's units) ----------
    // V: the screen where the swirl rests; VU: V together with the screen as it is at the count, where the swirl is
    // smaller (from there the pieces come in again while it grows back); SC: the screen now
    var V = null, B = null, VU = null, SC = null;
    // a disc out of sight of the screen S: wholly past its edge, or (box) wholly behind the box
    function hid(x, y, r, box, S) {
      if (x + r < S.l || x - r > S.r || y + r < S.t || y - r > S.b) return true;
      return box && x - r > B.l && x + r < B.r && y - r > B.t && y + r < B.b;
    }
    function far(x, y, m) { return x < VU.l - m || x > VU.r + m || y < VU.t - m || y > VU.b + m; }
    // where each point of what rides it sits on its lane: its place along it, along and across its direction there
    function mapOn(o, x, y, lo, hi, out) {
      var T = o.lane, k0 = 0, bd = 1e18;
      for (var k = 0; k < T.n; k++) { if (T.S[k] < lo || T.S[k] > hi) continue; var d = (T.X[k] - x) * (T.X[k] - x) + (T.Y[k] - y) * (T.Y[k] - y); if (d < bd) { bd = d; k0 = k; } }
      var u = T.S[k0]; at(T, u, F); var dx = x - F[0], dy = y - F[1];
      out.push(u, dx * F[2] + dy * F[3], -dx * F[3] + dy * F[2]);
    }
    function onLane(T, u, t, n, X, Y, j) { at(T, u, F); X[j] = F[0] + F[2] * t - F[3] * n; Y[j] = F[1] + F[3] * t + F[2] * n; }
    // the lane: back from the tail on its own bend and onto a spiral out of the screen (pointing out from the middle,
    // straight back in); the spine; on from the head the same way, out
    function laneOf(o) {
      var Dn = o.Dn, n = Dn.length, t0 = Dn[0], t1 = Dn[Math.min(n - 1, 3)], tl = Math.hypot(t1[0] - t0[0], t1[1] - t0[1]) || 1;
      var bx = -(t1[0] - t0[0]) / tl, by = -(t1[1] - t0[1]) / tl, pb = pitchOf(t0, bx, by), r0 = Math.hypot(t0[0] - C, t0[1] - C);
      var M = o.L + 2 * o.R + 60, stop = function (x, y) { return far(x, y, M); }, lim = function (k) { return Math.max(-1 / 150, Math.min(1 / 150, k)); };
      var back = wayOn(t0, bx, by, lim(-o.k0), pb < -60 * RD ? null : Math.max(PB, pb), Math.max(110, Math.min(260, .55 * r0)), Math.max(30, Math.min(140, .5 * o.L)), 6000, stop);
      var h1 = Dn[n - 1], h0 = Dn[Math.max(0, n - 4)], hl = Math.hypot(h1[0] - h0[0], h1[1] - h0[1]) || 1, fx = (h1[0] - h0[0]) / hl, fy = (h1[1] - h0[1]) / hl, pf = pitchOf(h1, fx, fy), lf = !!o.q.leaf;
      var on = wayOn(h1, fx, fy, lim(o.k1), pf < -60 * RD ? null : Math.max(PB, pf), lf ? 70 : Math.max(110, Math.min(260, .55 * Math.hypot(h1[0] - C, h1[1] - C))), lf ? 24 : Math.max(30, Math.min(140, .5 * o.L)), 6000, stop);
      o.lane = track(back.reverse().concat(Dn, on));
      o.uT = 0; for (var k = 0; k < o.lane.n; k++) if (Math.abs(o.lane.X[k] - t0[0]) + Math.abs(o.lane.Y[k] - t0[1]) < 1e-6) { o.uT = o.lane.S[k]; break; }
      o.uH = o.uT + o.L;
      at(o.lane, o.uH, F); o.hx = F[0]; o.hy = F[1]; o.hdx = F[2]; o.hdy = F[3];
    }
    // what rides a drop, set on its lane where it rests
    function mapRiders(o) {
      (o.riders || []).forEach(function (r) {
        var lo = o.uT - 700, hi = o.uH + 700, m = [];
        if (r.t === 'w') {
          var Dr = r.Dn, Sr = [0]; for (var j = 1; j < Dr.length; j++) Sr.push(Sr[j - 1] + Math.hypot(Dr[j][0] - Dr[j - 1][0], Dr[j][1] - Dr[j - 1][1]));
          var k = 0;
          for (j = 0; j < r.nb; j++) { var s = r.s[j] * r.L; while (k < Dr.length - 2 && Sr[k + 1] < s) k++; var f = (s - Sr[k]) / ((Sr[k + 1] - Sr[k]) || 1); mapOn(o, Dr[k][0] + (Dr[k + 1][0] - Dr[k][0]) * f, Dr[k][1] + (Dr[k + 1][1] - Dr[k][1]) * f, lo, hi, m); }
          r.mp = Float64Array.from(m); m = [];
          if (r.q.grad) { mapOn(o, r.q.grad.p0[0], r.q.grad.p0[1], lo, hi, m); mapOn(o, r.q.grad.p1[0], r.q.grad.p1[1], lo, hi, m); r.gp = Float64Array.from(m); }
        } else { mapOn(o, r.q.c[0], r.q.c[1], lo, hi, m); r.mp = Float64Array.from(m); }
      });
    }
    // the ends of its colour field, on its own body (past an end, straight on from it)
    function mapGrad(o) {
      if (!o.q.grad) return; var m = [];
      mapOn(o, o.q.grad.p0[0], o.q.grad.p0[1], o.uT, o.uH, m); mapOn(o, o.q.grad.p1[0], o.q.grad.p1[1], o.uT, o.uH, m);
      o.gp = Float64Array.from(m);
    }
    // is the drop out of sight of the screen S with its head at h, and all that rides it? (box: behind the box counts)
    function hiddenAt(o, h, box, S) {
      at(o.lane, h, F); if (!hid(F[0], F[1], o.R + 2, box, S)) return false;
      for (var j = o.nb - 1; j >= 0; j -= 2) { pos(o.lane, h - o.L + o.s[j] * o.L, F, 0); if (!hid(F[0], F[1], o.W[j] + 2, box, S)) return false; }
      var dl = h - o.uH, R = o.riders || [];
      for (var q = 0; q < R.length; q++) {
        var r = R[q], mp = r.mp;
        if (r.t === 'w') { for (j = 0; j < r.nb; j += 2) { onLane(o.lane, mp[3 * j] + dl, mp[3 * j + 1], mp[3 * j + 2], RX, RY, 0); if (!hid(RX[0], RY[0], r.W[j] + 2, box, S)) return false; } }
        else { onLane(o.lane, mp[0] + dl, mp[1], mp[2], RX, RY, 0); if (!hid(RX[0], RY[0], r.r + 2, box, S)) return false; }
      }
      return true;
    }
    var RX = new Float64Array(1), RY = new Float64Array(1);
    // where it starts (the nearest place back from where it rests where it is out of sight: hs for V, hsU for VU, as
    // far or farther back) and how far on it is gone from V (Dout)
    function ends(o) {
      var h, lo = o.L + 2;
      for (h = o.uH; h > lo; h -= 3) if (hiddenAt(o, h, true, V)) break;
      if (h <= lo) h = lo;
      while (h + 1 <= o.uH && hiddenAt(o, h + 1, true, V)) h += 1;
      o.hs = h; o.Din = o.uH - h;
      if (VU !== V) {
        for (h = o.hs; h > lo; h -= 3) if (hiddenAt(o, h, true, VU)) break;
        if (h <= lo) h = lo;
        while (h + 1 <= o.hs && hiddenAt(o, h + 1, true, VU)) h += 1;
      }
      o.hsU = Math.min(h, o.hs); o.DinU = o.uH - o.hsU;
      for (h = o.uH; h < o.lane.len + 2000; h += 4) if (hiddenAt(o, h, false, V)) break;
      o.Dout = h - o.uH;
    }
    // each one's moment and pace on the way in: lower layers land first, small drops and highlights last, a drop lands
    // after what it lies on and the two halves of a leaf together; a long way gets a little more time; bubbles rise all
    // through. On the way out the other way round: what landed last leaves first, a drop before what it lies on
    E.retime = function () {
      var N = DROPS.filter(function (o) { return !o.q.shade; }).length, k = 0, sup = function (w) { var s = P[w]; return s.base || s; };
      // (a flight is never faster than 1150 units a second on average: a long way starts at once and lands later)
      DROPS.forEach(function (o) {
        var lam = o.q.shade ? .05 * rnd(o.i + 7) : k++ / Math.max(1, N - 1), Tm = 1.2 + .55 * ss(o.Din, 250, 1400) + .12 * rnd(o.i + 19);
        o.tL = 1.2 + 1.5 * Math.pow(lam, 1.15) + .26 * (rnd(o.i + 23) - .5);
        o.T = Math.min(Tm, o.tL); if (o.T < o.Din / 1150) { o.T = o.Din / 1150; o.tL = Math.max(o.tL, o.T); }
        (o.q.on || []).forEach(function (w) { var s = sup(w); if (s !== o && s.tL !== undefined) o.tL = Math.max(o.tL, s.tL + .06); });
      });
      DROPS.forEach(function (o) { if (o.q.leaf) DROPS.forEach(function (b) { if (b !== o && b.q.leaf === o.q.leaf) o.tL = b.tL = Math.max(o.tL, b.tL); }); });
      P.forEach(function (o) {
        if (o.t === 'u') { o.tL = .9 + 1.9 * rnd(o.i + 181); o.T = Math.min(o.tL, 1.15 + .4 * rnd(o.i + 191)); }
        if (o.tL === undefined) return;
        o.t0 = o.tL - o.T;
      });
      E.T = Math.max.apply(null, P.map(function (o) { return o.T ? o.t0 + o.T : 0; })) + .7;
      var lo = 1e9, hi = -1e9; DROPS.forEach(function (o) { lo = Math.min(lo, o.tL); hi = Math.max(hi, o.tL); });
      DROPS.forEach(function (o) { o.xo = .85 * (hi - o.tL) / Math.max(.1, hi - lo) + .1 * rnd(o.i + 301); o.Tx = .85 + .35 * ss(o.Dout, 200, 1200) + .1 * rnd(o.i + 307); });
      DROPS.forEach(function (o) { if (o.q.leaf) DROPS.forEach(function (b) { if (b !== o && b.q.leaf === o.q.leaf) o.xo = b.xo = Math.min(o.xo, b.xo); }); });
      for (var pass = 0; pass < 3; pass++) DROPS.forEach(function (o) { (o.q.on || []).forEach(function (w) { var s = sup(w); if (s !== o && s.xo !== undefined && s.xo < o.xo + .06) s.xo = o.xo + .06; }); });
      P.forEach(function (o) { if (o.t === 'u') { o.xo = .05 + .8 * rnd(o.i + 311); o.Tx = 1 + .35 * rnd(o.i + 313); } });
    };
    // the soft springs of the scroll's jolt for the waves: one in the middle and six round it; a point of a wave
    // moves with the springs near it, so neighbours move together
    var JA = [];
    for (var q0 = 0; q0 < 7; q0++) { var an = q0 ? (q0 - 1) * TAU / 6 + .3 : 0, ra = q0 ? 330 : 0; JA.push({ x: C + ra * Math.cos(an), y: C + ra * Math.sin(an), jx: 0, jy: 0, jv: 0, jvx: 0, jw: TAU * (1 + .13 * ((q0 * 5) % 7)), jz: .15 + .03 * (q0 % 3), jg: .75 + .1 * ((q0 * 3) % 5), jk: ((q0 * 2) % 5 - 2) * .14 }); }
    var JON = false;
    function waveLike(o) { return o.t === 'w' && !o.q.rig; }
    // the lanes worked out for a screen: all at once (plan) or a piece at a time (planSteps: each call does one, true
    // when all are done), so a page can do it while it is idle. Vn: the screen where it rests ({l, r, t, b}), with its
    // box (Vn.box) and the screen at the count (Vn.far); worked out again only for a new screen. While pieces are on
    // their way their timing is kept.
    var PSIG = '';
    function sigOf(Vn) { var f = Vn.far || {}, b = Vn.box || {}; return [Vn.l, Vn.r, Vn.t, Vn.b, b.l, b.r, b.t, b.b, f.l, f.r, f.t, f.b].map(function (v) { return Math.round((v || 0) * 2); }).join(); }
    E.planSteps = function (Vn) {
      var sig = sigOf(Vn), i = 0, done = sig === PSIG;
      return function () {
        if (done) return true;
        if (i === 0) {
          V = Vn; B = Vn.box || { l: 305.7, r: 718.3, t: 298.7, b: 725.3 }; E.V = Vn;
          var f = Vn.far; VU = f ? { l: Math.min(V.l, f.l), r: Math.max(V.r, f.r), t: Math.min(V.t, f.t), b: Math.max(V.b, f.b) } : V;
          if (!SC) SC = V;
          // the eye's distance for the drop that comes at the screen: a little more than half the screen's diagonal
          var fv = f || V; E.DZ = 1.1 * Math.hypot(fv.r - fv.l, fv.b - fv.t) / 2;
        }
        if (i < DROPS.length) { var o = DROPS[i++]; laneOf(o); mapRiders(o); mapGrad(o); ends(o); return false; }
        P.forEach(function (o) {
          if (o.t !== 'u') return; var c = o.c, j = o.i, y = o.r + 40 + 60 * rnd(j + 89);
          o.x0 = c[0] + (rnd(j + 83) - .5) * 140; o.y0 = V.b + y; o.y0U = VU.b + y; if (o.y0E === undefined) o.y0E = o.y0;
          o.zz = 14 + 12 * rnd(j + 97); o.ph = rnd(j + 103) * TAU;
          o.px = 3.1 + 1.5 * rnd(j + 131); o.py = 2.4 + 1.2 * rnd(j + 137); o.qx = 7 + 5 * rnd(j + 139); o.qy = 9 + 6 * rnd(j + 149);
        });
        var busy = OWN.some(function (o) { return o.mode === 'wait' || o.mode === 'in' || o.mode === 'out'; });
        if (!busy || !E.T) E.retime();
        DROPS.forEach(function (o) {
          var j = o.i; o.Pa = 4.2 + 2 * rnd(j + 41); o.Pb = 6.3 + 2.5 * rnd(j + 43); o.ph = rnd(j + 47) * TAU;
          if (o.hsE === undefined || !busy) { o.hsE = o.hs; o.DinE = o.Din; }
        });
        P.forEach(function (o, j) {
          o.jw = TAU * (1 + .12 * ((j * 7) % 9)); o.jz = .14 + .03 * (j % 3); o.jg = (o.t === 'u' || o.t === 'g' ? -.5 : 1) * (.75 + .08 * ((j * 5) % 7)); o.jk = ((j * 3) % 5 - 2) * .14;
          o.bp = rnd(o.i + 211) * TAU; o.bq = 3.2 + 2 * rnd(o.i + 223);
        });
        PSIG = sig; done = true;
        return true;
      };
    };
    E.plan = function (Vn) { var step = E.planSteps(Vn); while (!step()); };
    E.planned = function (Vn) { return sigOf(Vn) === PSIG; };

    // ---------- the water: the pointer, taps, landings ----------
    var HIST = [], RIP = [], fin, prev, lastRip, acc, WN = 0;
    E.ripReset = function () { HIST = []; RIP = []; fin = { x: 0, y: 0, on: 0, live: false }; prev = null; lastRip = -9; acc = { dx: 0, dy: 0, t: -9 }; };
    E.ripReset();
    function emit(x, y, s) { RIP.push({ x: x, y: y, t: WN, s: s }); }
    E.emit = emit;
    E.tap = function (x, y) { emit(x, y, 1.3); };
    E.ripples = function () { return RIP.length; };
    E.waterStep = function (ptr, now, dt) {
      WN = now;
      if (ptr) {
        if (!fin.live) { fin.x = ptr[0]; fin.y = ptr[1]; fin.live = true; emit(ptr[0], ptr[1], .8); }
        var dx = prev ? ptr[0] - prev[0] : 0, dy = prev ? ptr[1] - prev[1] : 0, sp = dt > 0 ? Math.hypot(dx, dy) / dt : 0;
        // the pointer's drag, kept at most 40 times a second
        acc.dx += dx; acc.dy += dy;
        if ((acc.dx || acc.dy) && now - acc.t >= .025) { HIST.push({ x: ptr[0], y: ptr[1], dx: acc.dx, dy: acc.dy, t: now }); acc.dx = acc.dy = 0; acc.t = now; }
        if (sp > 40 * SK && now - lastRip > .13) { emit(ptr[0], ptr[1], Math.min(1, sp / (450 * SK))); lastRip = now; }
        prev = [ptr[0], ptr[1]]; var k = 1 - Math.exp(-dt / .07); fin.x += (ptr[0] - fin.x) * k; fin.y += (ptr[1] - fin.y) * k; fin.on += (1 - fin.on) * (1 - Math.exp(-dt / .25));
      } else { prev = null; fin.live = false; fin.on *= Math.exp(-dt / .45); acc.dx = acc.dy = 0; }
      while (HIST.length && now - HIST[0].t > 1.6) HIST.shift();
      while (RIP.length && now - RIP[0].t > 2.4) RIP.shift();
    };
    E.active = function () { return HIST.length > 0 || RIP.length > 0 || fin.on > .01; };
    // something still moves without the clocks: the water or the jolt
    E.busy = function () { return JON || E.active(); };
    var K1 = 4050 * SK * SK, K2 = 3200 * SK * SK, RL = 70 * SK, RV = 120 * SK, RW = 1352 * SK * SK, CAP = 24 * SK, WO = [0, 0];
    function water(x, y) {
      var dx = 0, dy = 0, i, s, rx, ry, r2, r, now = WN;
      for (i = 0; i < HIST.length; i++) { s = HIST[i]; rx = x - s.x; ry = y - s.y; r2 = rx * rx + ry * ry; if (r2 > 5 * K1) continue; var tau = now - s.t, g = .2 * Math.exp(-r2 / K1) * Math.exp(-tau / .5) * Math.cos(4.8 * tau); dx += s.dx * g; dy += s.dy * g; }
      if (fin.on > .01) { rx = x - fin.x; ry = y - fin.y; r = Math.hypot(rx, ry) || 1; var b = fin.on * 10 * SK * (r / (40 * SK)) * Math.exp(.5 - r * r / K2); dx += rx / r * b; dy += ry / r * b; }
      for (i = 0; i < RIP.length; i++) { s = RIP[i]; rx = x - s.x; ry = y - s.y; r = Math.hypot(rx, ry) || 1; var ta = now - s.t, u = r - RV * ta; if (u > 75 * SK || u < -75 * SK) continue; var a = 2.4 * SK * s.s * Math.exp(-u * u / RW) * Math.sin(TAU * u / RL) * Math.exp(-ta / .9) * ss(r, 0, 30 * SK); dx += rx / r * a; dy += ry / r * a; }
      var m = Math.hypot(dx, dy); if (m > CAP) { dx *= CAP / m; dy *= CAP / m; }
      WO[0] = dx; WO[1] = dy; return WO;
    }
    // ---------- the scroll's jolt ----------
    E.kick = function (I) {
      JA.forEach(function (a) { a.jv = Math.max(-150, Math.min(150, a.jv + I * a.jg)); a.jvx = Math.max(-70, Math.min(70, a.jvx + I * a.jk)); });
      P.forEach(function (o) { if (waveLike(o)) return; o.jv = Math.max(-150, Math.min(150, o.jv + I * o.jg)); o.jvx = Math.max(-70, Math.min(70, o.jvx + I * o.jk)); });
      JON = true;
    };
    function spring(o, h) { o.jv += (-o.jw * o.jw * o.jy - 2 * o.jz * o.jw * o.jv) * h; o.jy += o.jv * h; o.jvx += (-o.jw * o.jw * o.jx - 2 * o.jz * o.jw * o.jvx) * h; o.jx += o.jvx * h; }
    function jstep(dt) {
      while (dt > 1e-6) { var h = Math.min(dt, .016); dt -= h; for (var i = 0; i < P.length; i++) if (!waveLike(P[i])) spring(P[i], h); for (i = 0; i < 7; i++) spring(JA[i], h); }
      if (JON) { var m = 0; JA.forEach(function (a) { m = Math.max(m, Math.abs(a.jx) + Math.abs(a.jy) + .05 * (Math.abs(a.jv) + Math.abs(a.jvx))); }); if (m < .01) { JON = false; JA.forEach(function (a) { a.jx = a.jy = a.jv = a.jvx = 0; }); } }
    }
    var JQ = [0, 0];
    function joltAt(x, y) {
      var sw = 0, dx = 0, dy = 0;
      for (var q = 0; q < 7; q++) { var a = JA[q], w = Math.exp(-((x - a.x) * (x - a.x) + (y - a.y) * (y - a.y)) / 80000); sw += w; dx += w * a.jx; dy += w * a.jy; }
      if (sw < 1e-12) { JQ[0] = JQ[1] = 0; } else { JQ[0] = dx / sw; JQ[1] = dy / sw; } return JQ;
    }

    // ---------- what each piece does: told by enter and leave ----------
    // mode: off (never come in, or told not to), wait (comes in at ts), in (on its way in), rest, out (on its way out),
    // gone (out of sight; it comes in again when told to)
    function start(o, t) {
      o.mode = 'wait'; o.ts = Math.max(t, E.tIn + o.t0); o.tl = o.ts + o.T; o.xs = undefined; o.fly = null;
      if (o.t === 'w') { o.hsE = E.farIn ? o.hsU : o.hs; o.DinE = o.uH - o.hsE; } else o.y0E = E.farIn ? o.y0U : o.y0;
    }
    // come in: what is out of sight comes in as at the start (what is still on its way out goes on out first); what
    // had not left yet stays; the drop that came at the screen turns and flies back to its place. far: the swirl is
    // still smaller than where it rests (its pieces start farther out)
    E.enter = function (t, far) {
      E.want = 'in'; E.tIn = t; E.farIn = !!far;
      OWN.forEach(function (o) {
        if (o === E.bg && o.mode === 'fly') { if (E.fl.kind === 'come') backAt(o, t); E.fl.after = false; return; }
        if (o.mode === 'off' || o.mode === 'gone') start(o, t);
        else if (o.mode === 'rest') o.xs = undefined;
      });
      E.mov = true;
    };
    // go: each at its moment, head first on along its lane (a bubble up); what is flying in flies on through its place
    // and out; what had not started stays away; withBg: the drop opt.bg comes at the screen instead (without, if it is
    // on its way at the screen it first flies back to its place and then leaves)
    E.leave = function (t, withBg) {
      E.want = 'out';
      OWN.forEach(function (o) {
        if (o === E.bg) {
          if (withBg) { if (o.mode !== 'fly' || E.fl.kind !== 'come') comeAt(o, t); return; }
          if (o.mode === 'fly') { if (E.fl.kind === 'come') backAt(o, t); E.fl.after = true; return; }
        }
        if (o.mode === 'wait' || o.mode === 'off') { o.mode = 'off'; return; }
        if (o.mode === 'in') { flyOn(o, t); return; }
        if (o.mode === 'rest') o.xs = t + o.xo;
      });
      E.mov = true;
    };
    function flyOn(o, t) {
      o.mode = 'out'; o.tx = t;
      if (o.t === 'u') { o.up = upOf(o); return; }
      var x = (t - o.ts) / o.T, h0 = o.hsE + o.DinE * ein(x), v0 = evel(x) * o.DinE / o.T, left = o.uH + o.Dout - h0;
      o.fly = { h0: h0, v0: v0, a: Math.max(250, 2 * (left - v0 * 1.5) / 2.25) };
    }
    // how far up a bubble rises to be out of sight (from where it rests, to past the top of the screen now)
    function upOf(o) { return o.c[1] + o.r * 1.4 - SC.t + 30; }

    // ---------- the drop that comes at the screen, in 3D ----------
    // Its ways are points x y z: x y in the swirl's units, z its depth from the eye. The swirl lies at z = DZ, where a
    // point is seen where it is; nearer, it is seen at c + (p - c) DZ / z (c: the middle of the screen), and bigger by
    // DZ / z. A way is laid out as it is to be seen (a curve on the screen, and its depth along it), after the drop's
    // body as it is when it sets off, so its body follows its head through every turn; its head goes along it by the
    // curve's own steps (w), slow to start (or at the speed it had) and as fast as told at the end.
    function track3(cap) { return { X: new Float64Array(cap), Y: new Float64Array(cap), Z: new Float64Array(cap), S: new Float64Array(cap), n: 0, len: 0 }; }
    function t3add(T, x, y, z) {
      var n = T.n;
      if (n) { var d = Math.hypot(x - T.X[n - 1], y - T.Y[n - 1], z - T.Z[n - 1]); if (d < 1e-6) return false; T.S[n] = T.S[n - 1] + d; } else T.S[0] = 0;
      T.X[n] = x; T.Y[n] = y; T.Z[n] = z; T.n = n + 1; T.len = T.S[n]; return true;
    }
    // the point at distance d along a way (past either end straight on)
    function t3at(T, d, o) {
      var S = T.S, n = T.n, lo, hi;
      if (d <= 0) { lo = 0; hi = 1; } else if (d >= T.len) { lo = n - 2; hi = n - 1; }
      else { lo = 0; hi = n - 1; while (hi - lo > 1) { var m = (lo + hi) >> 1; if (S[m] <= d) lo = m; else hi = m; } }
      var f = (d - S[lo]) / ((S[hi] - S[lo]) || 1);
      o[0] = T.X[lo] + (T.X[hi] - T.X[lo]) * f; o[1] = T.Y[lo] + (T.Y[hi] - T.Y[lo]) * f; o[2] = T.Z[lo] + (T.Z[hi] - T.Z[lo]) * f;
      return o;
    }
    // a way as it is to be seen, added to a track in n steps: the curve Q0..Q3 on the screen (seen round c, the eye's
    // distance DZ) and the depth z(w) along it; the track's length after each step goes into Wl
    function way3(T, Q0, Q1, Q2, Q3, zOf, cx, cy, DZ, n, Wl) {
      for (var i = 1; i <= n; i++) {
        var u = i / n, v = 1 - u, a = v * v * v, b = 3 * v * v * u, c = 3 * v * u * u, d = u * u * u, z = zOf(u);
        var qx = a * Q0[0] + b * Q1[0] + c * Q2[0] + d * Q3[0], qy = a * Q0[1] + b * Q1[1] + c * Q2[1] + d * Q3[1];
        t3add(T, cx + (qx - cx) * z / DZ, cy + (qy - cy) * z / DZ, z); Wl.push(T.len);
      }
    }
    // how far along its way its head is at t (w), and where that is along its track
    function wAt(f, t) { var x = cl((t - f.t0) / f.T), x2 = x * x, x3 = x2 * x; return cl(3 * x2 - 2 * x3 + f.m0 * (x3 - 2 * x2 + x) + f.m1 * (x3 - x2)); }
    function flArc(f, t) { var w = wAt(f, t), n = f.Wl.length - 1, k = Math.min(n - 1, Math.floor(w * n)), r = w * n - k; return f.Wl[k] + (f.Wl[k + 1] - f.Wl[k]) * r; }
    // its speed along its track at the start, as the slope of w (so a new way goes on at the speed it had)
    function slope(f, v) { var n = f.Wl.length - 1; return Math.min(2.6, v * f.T / Math.max(1e-6, (f.Wl[1] - f.Wl[0]) * n)); }
    var Q3 = [0, 0, 0], Q4 = [0, 0, 0];
    // its body's length along its way now: at least its own; as long as it was when it turned, drawing in to its own
    // length; and back to where its head was a while before: on its way at the screen a moment at first (it keeps its
    // shape), TL s once it is fast and near (its tail trails far back); on its way back TL s from the screen, a moment from a turn, drawing
    // in to nothing (so it lands in its shape)
    function spanAt(f, o, t) {
      var x = (t - f.t0) / f.T, b = o.L + (f.B0 - o.L) * Math.exp(-Math.max(0, t - f.t0) / .3) * (f.kind === 'back' ? 1 - ss(x, .6, .97) : 1);
      var lag = f.kind === 'come' ? .12 + (TL - .12) * ss(x, .3, .75) : (f.full ? TL : .25) * (1 - ss(x, .35, .9));
      return Math.max(b, flArc(f, t) - flArc(f, t - lag) + o.L);
    }
    // where it is now: its body as points in 3D (from a way back of its tail to its head), its head's speed along its
    // way and its heading
    function bodyNow(o, t) {
      var pts = [], L = o.L, f = E.fl, h, h1, dir, d, sp = L;
      if (o.mode === 'fly' && f) {
        h = flArc(f, t); h1 = flArc(f, t - .02); sp = spanAt(f, o, t);
        for (d = h - sp - 24; d < h; d += 4) { t3at(f.tr, d, Q3); pts.push([Q3[0], Q3[1], Q3[2]]); }
        t3at(f.tr, h, Q3); pts.push([Q3[0], Q3[1], Q3[2]]); t3at(f.tr, h - 3, Q4);
        dir = [Q3[0] - Q4[0], Q3[1] - Q4[1], Q3[2] - Q4[2]];
      } else {
        h = headAt(o, t); h1 = headAt(o, t - .02);
        // not there: from just out of sight on its lane, as at its way in
        if (h !== h) { h = E.farIn ? o.hsU : o.hs; h1 = h - 12; }
        if (h1 !== h1) h1 = h;
        for (d = h - L - 24; d < h; d += 4) { pos(o.lane, d, F, 0); pts.push([F[0], F[1], E.DZ]); }
        at(o.lane, h, F); pts.push([F[0], F[1], E.DZ]); dir = [F[2], F[3], 0];
      }
      var dl = Math.hypot(dir[0], dir[1], dir[2]) || 1;
      return { pts: pts, v: Math.max(0, (h - h1) / .02), dir: [dir[0] / dl, dir[1] / dl, dir[2] / dl], sp: sp };
    }
    // a heading in 3D at H as it is seen (round the eye c)
    function seen(H, d, cx, cy, DZ) {
      var e = .02 * H[2], z1 = Math.max(1e-3, H[2] + d[2] * e), k0 = DZ / H[2], k1 = DZ / z1;
      var x = (H[0] + d[0] * e - cx) * k1 - (H[0] - cx) * k0, y = (H[1] + d[1] * e - cy) * k1 - (H[1] - cy) * k0, l = Math.hypot(x, y);
      return l > 1e-9 ? [x / l, y / l] : [0, -1];
    }
    // the eye: the middle of the screen at the count, the same for every flight (the screen moves on with the box while
    // the drop sets off, and a point near the eye seen round another middle would be far from where its way was laid out)
    function eye() { var fr = V.far || V; return [(fr.l + fr.r) / 2, (fr.t + fr.b) / 2]; }
    function newTrack(P, extra) { var T = track3(P.length + extra); P.forEach(function (q) { t3add(T, q[0], q[1], q[2]); }); return T; }
    // it comes at the screen: on from where it is as it heads now, curving round over the box (as seen) to a point
    // well above it, three quarters of the way from the box's middle towards the screen's, nearer and nearer (its depth in even steps of log z,
    // most of them late), until its head covers the screen at the count (V.far) with a tenth to spare
    function comeAt(o, t) {
      var b = bodyNow(o, t), P = b.pts, H = P[P.length - 1], DZ = E.DZ, fr = V.far || V, ey = eye(), cx = ey[0], cy = ey[1];
      var k0 = DZ / H[2], Q0 = [cx + (H[0] - cx) * k0, cy + (H[1] - cy) * k0], hd = seen(H, b.dir, cx, cy, DZ);
      var px = (B.l + B.r) / 2 + .75 * (cx - (B.l + B.r) / 2), py = Math.min(cy, B.t - 6 * o.R - .25 * Math.max(0, B.t - fr.t)), mc = 0;
      [[fr.l, fr.t], [fr.r, fr.t], [fr.l, fr.b], [fr.r, fr.b]].forEach(function (q) { mc = Math.max(mc, Math.hypot(q[0] - px, q[1] - py)); });
      var ze = o.R * DZ / (1.1 * mc), z0 = H[2], lz = Math.log(ze / z0);
      // it comes in from its own side, level or from above
      var sx = Q0[0] - px, sy = Math.min(0, Q0[1] - py), sl = Math.hypot(sx, sy) || 1, dq = Math.hypot(Q0[0] - px, Q0[1] - py);
      // (on as it heads the farther the more that leads towards where it goes: heading away it turns soon)
      var ah = .35 + .35 * Math.max(0, (hd[0] * (px - Q0[0]) + hd[1] * (py - Q0[1])) / (dq || 1));
      var Q1 = [Q0[0] + hd[0] * ah * dq, Q0[1] + hd[1] * ah * dq], Q2 = [px + sx / sl * .55 * dq, py + sy / sl * .55 * dq];
      var T = newTrack(P, 200), Wl = [T.len];
      way3(T, Q0, Q1, Q2, [px, py], function (w) { return z0 * Math.exp(lz * Math.pow(w, PZ)); }, cx, cy, DZ, 180, Wl);
      var f = E.fl = { kind: 'come', t0: t, T: TC, tr: T, Wl: Wl, DZ: DZ, cx: cx, cy: cy, B0: b.sp, after: false, done: false, m1: 1.5 };
      f.m0 = slope(f, b.v);
      o.mode = 'fly'; o.xs = undefined; o.fly = null; o.after = false;
    }
    // it goes back: on from where it is as it heads now (as seen), turning and curving down to its lane LBK behind its
    // tail, farther and farther (its depth in even steps of log z, most of them early: it is soon small again), and in
    // along its lane to where it rests, slowing as it lands
    function backAt(o, t) {
      var f0 = E.fl, b = bodyNow(o, t), P = b.pts, H = P[P.length - 1], DZ = f0 ? f0.DZ : E.DZ, ey = f0 ? [f0.cx, f0.cy] : eye(), cx = ey[0], cy = ey[1];
      var k0 = DZ / H[2], Q0 = [cx + (H[0] - cx) * k0, cy + (H[1] - cy) * k0], hd = seen(H, b.dir, cx, cy, DZ);
      var uA = o.uH - o.L - LBK; at(o.lane, uA, F);
      var A = [F[0], F[1]], tx = F[2], ty = F[3], dq = Math.hypot(A[0] - Q0[0], A[1] - Q0[1]), z0 = H[2], lz = Math.log(DZ / z0);
      var Q1 = [Q0[0] + hd[0] * .35 * dq, Q0[1] + hd[1] * .35 * dq], Q2 = [A[0] - tx * .45 * dq, A[1] - ty * .45 * dq];
      var T = newTrack(P, 260 + Math.ceil((o.L + LBK) / 2)), Wl = [T.len];
      way3(T, Q0, Q1, Q2, A, function (w) { return z0 * Math.exp(lz * (1 - Math.pow(1 - w, 2.4))); }, cx, cy, DZ, 150, Wl);
      // on along its lane in even steps about as long as the way's last, so it goes on at the same speed
      var ns = Math.max(1, Math.round((o.uH - uA) / Math.max(2, Wl[Wl.length - 1] - Wl[Wl.length - 2]))), st = (o.uH - uA) / ns;
      for (var q = 1; q <= ns; q++) { pos(o.lane, uA + q * st, F, 0); if (t3add(T, F[0], F[1], DZ)) Wl.push(T.len); }
      var f = E.fl = { kind: 'back', t0: t, T: TB, tr: T, Wl: Wl, DZ: DZ, cx: cx, cy: cy, B0: b.sp, full: !!(f0 && f0.done), g0: E.gz || (f0 && f0.done ? 1 : 0), after: f0 ? f0.after : false, done: false };
      f.m0 = Math.max(slope(f, b.v), f0 && f0.done ? .7 : 0); f.m1 = Math.min(1, 150 * TB / ((Wl[Wl.length - 1] - Wl[Wl.length - 2]) * (Wl.length - 1)));
      o.mode = 'fly';
    }
    // landed: at rest on its lane again, sloshing on at the speed it came in with
    function land(o, t) {
      var f = E.fl, n = f.Wl.length - 1, v = f.m1 * (f.Wl[n] - f.Wl[n - 1]) * n / f.T;
      E.fl = null; E.gl = null;
      o.mode = 'rest'; o.tl = t; o.ts = t - o.T; o.ramp = 0; o.DinE = v * o.T / VEND; o.hsE = o.uH - o.DinE;
      emit(o.hx, o.hy, .45 + .6 * Math.min(1, o.R / 40));
      if (f.after && E.want === 'out') o.xs = t;
    }
    // at once: all at rest, no ripples (with reduced motion, or jumping in past the count)
    E.settle = function () {
      E.want = 'in'; E.gz = 0; E.fl = null; E.gl = null;
      OWN.forEach(function (o) { o.mode = 'rest'; o.ts = o.tl = -1e9; o.xs = undefined; o.fly = null; o.after = false; if (o.t === 'w') { o.hsE = o.hs; o.DinE = o.Din; } else o.y0E = o.y0; });
    };
    // at once: all gone and the drop over the whole screen (jumping in deep past the count)
    E.cover = function () {
      E.settle(); E.want = 'out';
      OWN.forEach(function (o) { if (o !== E.bg) { o.mode = 'gone'; o.vis = false; } });
      if (E.bg) { comeAt(E.bg, 0); E.fl.t0 = -1e9; E.fl.done = true; E.gz = 1; }
    };
    // once out of sight: gone, and in again at its moment if it is to come in
    function goneNow(o, t) { o.mode = 'gone'; o.vis = false; o.fly = null; if (E.want === 'in') start(o, t + .08); }

    // ---------- each piece where it is now ----------
    // the fields every point of a wave moves with: the jolt's springs, the current at rest (g), the water (smooth over
    // a much longer reach than a few points, so worked out at every third one and drawn between)
    var CQ = [0, 0], WX = new Float64Array(512), WY = new Float64Array(512);
    function fields(X, Y, n, now, act, g) {
      for (var j = 0; j < n; j++) {
        var x0 = X[j], y0 = Y[j], x = x0, y = y0;
        if (JON) { joltAt(x0, y0); x += JQ[0]; y += JQ[1]; }
        if (g > .001) { current(x0, y0, now, CQ); x += CQ[0] * g; y += CQ[1] * g; }
        X[j] = x; Y[j] = y;
      }
      if (!act) return;
      var k = n > 6 ? 3 : 1;
      for (j = 0; j < n; j += k) { water(X[j], Y[j]); WX[j] = WO[0]; WY[j] = WO[1]; }
      var last = n - 1 - (n - 1) % k;
      if (last !== n - 1) { water(X[n - 1], Y[n - 1]); WX[n - 1] = WO[0]; WY[n - 1] = WO[1]; }
      for (j = 0; j < n; j++) {
        var r = j % k;
        if (r && j < last) { var a = j - r, b = a + k, f = r / k; WX[j] = WX[a] + (WX[b] - WX[a]) * f; WY[j] = WY[a] + (WY[b] - WY[a]) * f; }
        else if (j > last && j < n - 1) { var f2 = (j - last) / (n - 1 - last); WX[j] = WX[last] + (WX[n - 1] - WX[last]) * f2; WY[j] = WY[last] + (WY[n - 1] - WY[last]) * f2; }
        X[j] += WX[j]; Y[j] += WY[j];
      }
    }
    // a piece's own jolt and the water, at its centre
    var OQ = [0, 0];
    function own(o, x, y, act) {
      x += o.jx; y += o.jy;
      if (act) { water(x, y); x += WO[0]; y += WO[1]; }
      OQ[0] = x; OQ[1] = y; return OQ;
    }
    // a drop's head along its lane now (NaN: out of sight)
    function headAt(o, t) {
      var m = o.mode;
      if (m === 'off' || m === 'wait' || m === 'gone') return NaN;
      if (m === 'in') return o.hsE + o.DinE * ein((t - o.ts) / o.T);
      if (m === 'out' && o.fly) { var f = o.fly, tau = t - o.tx; return f.h0 + f.v0 * tau + .5 * f.a * tau * tau; }
      var h = o.uH + slosh(t - o.tl, VEND * o.DinE / o.T, 7.5, .42);
      if (m === 'out') h += o.Dout * eout((t - o.tx) / o.Tx);
      return h;
    }
    // the drop's outline round its spine (SPX, SPY: tail tip .. head centre): the left side, the half circle round the
    // nose, the right side back (its half widths W and the nose's radius R: its own, or as seen nearer)
    function outline(o, W, R) {
      W = W || o.W; R = R || o.R;
      var n = o.nb, X = o.SPX, Y = o.SPY, OX = o.OX, OY = o.OY, m = o.nc, tx = 1, ty = 0;
      for (var j = 0; j < n; j++) {
        var a = j ? j - 1 : 0, b = j < n - 1 ? j + 1 : n - 1, dx = X[b] - X[a], dy = Y[b] - Y[a], l = Math.hypot(dx, dy) || 1, w = W[j];
        tx = dx / l; ty = dy / l;
        OX[j] = X[j] - ty * w; OY[j] = Y[j] + tx * w;
        if (j) { OX[2 * n + m - 2 - j] = X[j] + ty * w; OY[2 * n + m - 2 - j] = Y[j] - tx * w; }
      }
      var e = n - 1, a0 = Math.atan2(tx, -ty);
      for (var k = 1; k < m; k++) { var an = a0 - Math.PI * k / m; OX[n - 1 + k] = X[e] + R * Math.cos(an); OY[n - 1 + k] = Y[e] + R * Math.sin(an); }
    }
    // a small drop at rest bobs as one: on along its heading and to the side, turning a little; and its own jolt and
    // the water at its middle
    function bob(o, now, act) {
      var n = o.nb, X = o.SPX, Y = o.SPY, j = Math.round(.6 * (n - 1)), cx = X[j], cy = Y[j], hx = X[n - 1] - X[Math.max(0, n - 4)], hy = Y[n - 1] - Y[Math.max(0, n - 4)], hl = Math.hypot(hx, hy) || 1, lv = o.ramp;
      hx /= hl; hy /= hl;
      var fw = 7 * SK * wob(now, o.Pa, o.Pb, o.ph) * lv, sd = 4.5 * SK * Math.sin(TAU * now / o.Pb + o.ph) * lv, rot = .07 * Math.sin(TAU * now / o.Pb + o.ph + .8) * lv;
      own(o, cx + hx * fw - hy * sd, cy + hy * fw + hx * sd, act);
      var c = Math.cos(rot), s = Math.sin(rot), dx = OQ[0] - cx, dy = OQ[1] - cy;
      o.tf2 = { cx: cx, cy: cy, c: c, s: s, dx: dx, dy: dy };
      turn(o.tf2, X, Y, n); if (o.gp) turn(o.tf2, o.GX, o.GY, 2);
    }
    function turn(t, X, Y, n) { for (var j = 0; j < n; j++) { var x = X[j] - t.cx, y = Y[j] - t.cy; X[j] = t.cx + x * t.c - y * t.s + t.dx; Y[j] = t.cy + x * t.s + y * t.c + t.dy; } }
    function placeDrop(o, t, now, act) {
      var h = headAt(o, t);
      if (h !== h) { o.vis = false; return; }
      o.vis = true; o.dl = h - o.uH;
      var n = o.nb, X = o.SPX, Y = o.SPY, b0 = h - o.L, L = o.L;
      for (var j = 0; j < n; j++) { pos(o.lane, b0 + o.s[j] * L, F, 0); X[j] = F[0]; Y[j] = F[1]; }
      if (o.gp) { onLane(o.lane, o.gp[0] + o.dl, o.gp[1], o.gp[2], o.GX, o.GY, 0); onLane(o.lane, o.gp[3] + o.dl, o.gp[4], o.gp[5], o.GX, o.GY, 1); }
      if (o.q.rig) bob(o, now, act);
      else { var g = E.gr * o.ramp; fields(X, Y, n, now, act, g); if (o.gp) fields(o.GX, o.GY, 2, now, act, g); }
      outline(o);
    }
    // in its flight: its body back from its head along its way, each point seen in perspective (nearer, bigger); the
    // part of its body that is nearer than its head and very near the eye is left out (seen far too big: it is where
    // it has just come from on its way back), and what shows is drawn as the whole drop, shorter; a wobble like water
    // while it flies; its glint, seen as it comes nearer, slides out over its rim as it covers the screen
    var PW = new Float64Array(512);
    function placeFly(o, t, now, act) {
      var f = E.fl, h = flArc(f, t), n = o.nb, L = o.L, DZ = f.DZ, cx = f.cx, cy = f.cy, X = o.SPX, Y = o.SPY, j, d, k;
      var sp = spanAt(f, o, t);
      t3at(f.tr, h, Q3); var zh = Math.max(1, Q3[2]), vis = sp;
      for (d = 4; d < sp + 4; d += 4) { t3at(f.tr, h - Math.min(d, sp), Q4); if (Q4[2] < zh - 1 && Q4[2] < DZ / 5) { vis = Math.max(0, d - 4); break; } }
      var x = cl((t - f.t0) / f.T), tau = t - f.t0, wb = f.kind === 'come' ? ss(x, .04, .2) * (1 - ss(x, .55, .8)) : ss(x, .3, .45) * (1 - ss(x, .75, .92));
      for (j = 0; j < n; j++) {
        var u = 1 - o.s[j], sg = 1 - u * u;
        t3at(f.tr, h - u * u * vis, Q4); k = DZ / Math.max(1, Q4[2]);
        X[j] = cx + (Q4[0] - cx) * k; Y[j] = cy + (Q4[1] - cy) * k;
        PW[j] = o.R * Math.sin(Math.PI / 2 * sg) * Math.min(k, DZ / zh) * (1 + .05 * wb * Math.sin(TAU * (2.3 * tau - .9 * sg)));
      }
      t3at(f.tr, h - sp, Q4); var kt = DZ / Math.max(1, Q4[2]), tx = cx + (Q4[0] - cx) * kt, ty = cy + (Q4[1] - cy) * kt;
      var kh = DZ / zh, Rh = o.R * kh * (1 + .035 * wb * Math.sin(TAU * 2.3 * tau + 1.1));
      // the current lets go of it as it leaves (and takes it again once it has landed); the water moves it as it moves
      // every drop on its way (seen near, by nothing one could see)
      var g = E.gr * o.ramp; if (g > .001 || JON || act) fields(X, Y, n, now, act, g);
      // its colour field's two ends where they lie on its body, flatter and flatter as it comes nearer
      if (o.gp) for (var e = 0; e < 2; e++) {
        var de = (o.gp[3 * e] + o.gp[3 * e + 1] - o.uH) * vis / L; t3at(f.tr, h + de, Q4); var ke = DZ / Math.max(1, Q4[2]), ex = cx + (Q4[0] - cx) * ke, ey = cy + (Q4[1] - cy) * ke;
        t3at(f.tr, h + de - 2, Q3); var k2 = DZ / Math.max(1, Q3[2]), dx = ex - (cx + (Q3[0] - cx) * k2), dy = ey - (cy + (Q3[1] - cy) * k2), dl = Math.hypot(dx, dy) || 1;
        o.GX[e] = ex - dy / dl * o.gp[3 * e + 2] * ke; o.GY[e] = ey + dx / dl * o.gp[3 * e + 2] * ke;
      }
      if (o.gp && (g > .001 || JON || act)) fields(o.GX, o.GY, 2, now, act, g);
      o.flat = ss(kh, 2.5, 12);
      outline(o, PW, Rh);
      o.vis = true; o.dl = 0; o.Rh = Rh;
      // as the art draws a drop: its head's circle and straight sides to its tail's tip, over its body as seen (whose
      // part behind the head, much farther, is seen much thinner), so it stays one clean drop as it comes nearer
      if (vis >= sp - 1e-6) { tx = X[0]; ty = Y[0]; }
      var dx2 = tx - X[n - 1], dy2 = ty - Y[n - 1], D = Math.hypot(dx2, dy2);
      o.hull = D > Rh * 1.02 ? { x: tx, y: ty, a: Math.atan2(dy2, dx2), b: Math.acos(Rh / D) } : null;
      var hx = X[n - 1] - X[n - 2], hy = Y[n - 1] - Y[n - 2]; o.ha = Math.atan2(hy, hx); o.sq = 1 + .09 * wb * (.5 + .5 * Math.sin(TAU * 1.9 * tau));
      var gs = ss(kh, 1.15, 2.4), m = 1 + 1.5 * ss(kh, 14, 60);
      E.gl = gs > .01 ? { x: X[n - 1] - .42 * m * Rh, y: Y[n - 1] - .46 * m * Rh, rx: .24 * gs * Rh, ry: .13 * gs * Rh } : null;
      E.gz = f.kind === 'come' ? wAt(f, t) : f.g0 * (1 - wAt(f, t));
    }
    // a shade rides its wave's lane, its own spine and widths kept
    function placeShade(o, now, act) {
      var b = o.base;
      if (!b.vis || b.mode === 'fly') { o.vis = false; return; }
      o.vis = true; o.ramp = b.ramp;
      var n = o.nb, X = o.SPX, Y = o.SPY, mp = o.mp;
      for (var j = 0; j < n; j++) onLane(b.lane, mp[3 * j] + b.dl, mp[3 * j + 1], mp[3 * j + 2], X, Y, j);
      if (o.gp) { onLane(b.lane, o.gp[0] + b.dl, o.gp[1], o.gp[2], o.GX, o.GY, 0); onLane(b.lane, o.gp[3] + b.dl, o.gp[4], o.gp[5], o.GX, o.GY, 1); }
      if (b.q.rig) { turn(b.tf2, X, Y, n); if (o.gp) turn(b.tf2, o.GX, o.GY, 2); }
      else { var g = E.gr * b.ramp; fields(X, Y, n, now, act, g); if (o.gp) fields(o.GX, o.GY, 2, now, act, g); }
      outline(o);
    }
    // a circle placed: turned by rot about its centre, stretched along dir by st (its area kept), scaled by sc, its
    // centre at (x, y)
    function rigid(o, x, y, rot, dir, st, sc) {
      var c = o.c, cr = Math.cos(rot), sr = Math.sin(rot), cd = Math.cos(dir), sd = Math.sin(dir), is = 1 / st;
      for (var j = 0; j < o.x.length; j++) {
        var lx = o.x[j] - c[0], ly = o.y[j] - c[1], ax = lx * cr - ly * sr, ay = lx * sr + ly * cr, a = (ax * cd + ay * sd) * st * sc, bb = (-ax * sd + ay * cd) * is * sc;
        o.X[j] = x + a * cd - bb * sd; o.Y[j] = y + a * sd + bb * cd;
      }
      o.tf = { x: x, y: y, cr: cr, sr: sr, cd: cd, sd: sd, st: st, dir: dir, sc: sc };
      o.vis = true;
    }
    // where a point of a circle's art is now
    function carry(h, px, py, out) {
      var t = h.tf, lx = px - h.c[0], ly = py - h.c[1], ax = lx * t.cr - ly * t.sr, ay = lx * t.sr + ly * t.cr, a = (ax * t.cd + ay * t.sd) * t.st * t.sc, b = (-ax * t.sd + ay * t.cd) / t.st * t.sc;
      out[0] = t.x + a * t.cd - b * t.sd; out[1] = t.y + a * t.sd + b * t.cd; return out;
    }
    // a bubble: up from below to its place (x 0..1 of its rise), bobbing once there; on its way out it rises on from
    // wherever its way in has it, faster and faster
    var B1 = [0, 0], B2 = [0, 0], RQ = [0, 0];
    function bAt(o, t, now, out) {
      var x = cl((t - o.ts) / o.T), ez = 1 - Math.pow(1 - x, 2.4), lv = o.ramp;
      out[0] = o.x0 + (o.c[0] - o.x0) * ez + o.zz * Math.sin(ez * 7 + o.ph) * (1 - ez) + o.qx * Math.sin(TAU * now / o.px + o.ph) * lv;
      out[1] = o.y0E + (o.c[1] - o.y0E) * ez + o.qy * Math.sin(TAU * now / o.py + o.ph * 1.7) * lv;
      if (o.mode === 'out') { var tau = t - o.tx, d = o.up * eout(tau / o.Tx); out[1] -= d; out[0] += .5 * o.zz * Math.sin(d / 45 + o.ph) * cl(tau / o.Tx); }
      return out;
    }
    function placeBubble(o, t, now, act) {
      var m = o.mode;
      if (m === 'off' || m === 'wait' || m === 'gone') { o.vis = false; return; }
      bAt(o, t, now, B1); bAt(o, t - .03, now - .03, B2);
      var vx = B1[0] - B2[0], vy = B1[1] - B2[1], sp = Math.hypot(vx, vy) / .03, f = .16 * Math.min(1, sp / (60 * SK)) + .06 * Math.sin(17 * now + o.ph) * Math.min(1, sp / (30 * SK));
      own(o, B1[0], B1[1], act);
      // it flattens across its way while it rises fast
      rigid(o, OQ[0], OQ[1], 0, sp > 1 ? Math.atan2(vy, vx) : -Math.PI / 2, 1 / (1 + f), 1);
      if (m === 'out' && (OQ[1] + o.r * 1.4 < SC.t || t - o.tx > 5)) goneNow(o, t);
    }
    // a speck rides its drop (on that drop's lane, with the water there); a glint rides its bubble (or speck); each
    // with a small bob of its own once it has landed
    var SX = new Float64Array(1), SY = new Float64Array(1);
    function placeRider(o, now, act) {
      var h = o.host;
      if (!h || !h.vis || (o.base && o.base.mode === 'fly')) { o.vis = false; return; }
      o.alpha = h.alpha;
      var b = o.base, lv = b ? b.ramp : h.ramp, bx = 2.2 * Math.sin(TAU * now / o.bq + o.bp) * lv, by = 2.2 * Math.cos(TAU * now / (o.bq * 1.3) + o.bp) * lv;
      if (b) {
        onLane(b.lane, o.mp[0] + b.dl, o.mp[1], o.mp[2], SX, SY, 0);
        if (b.q.rig) turn(b.tf2, SX, SY, 1); else fields(SX, SY, 1, now, act, E.gr * b.ramp);
        rigid(o, SX[0] + bx, SY[0] + by, 0, 0, 1, 1);
      } else {
        carry(h, o.c[0], o.c[1], RQ);
        rigid(o, RQ[0] + bx, RQ[1] + by, 0, h.tf.dir, h.tf.st, h.tf.sc);
      }
      if (o.alpha <= 0) o.vis = false;
    }
    // is a drop, and all that rides it, wholly past the screen now?
    function pastAll(X, Y, n, r) {
      var x0 = 1e9, x1 = -1e9, y0 = 1e9, y1 = -1e9;
      for (var j = 0; j < n; j++) { if (X[j] < x0) x0 = X[j]; if (X[j] > x1) x1 = X[j]; if (Y[j] < y0) y0 = Y[j]; if (Y[j] > y1) y1 = Y[j]; }
      return x1 + r < SC.l || x0 - r > SC.r || y1 + r < SC.t || y0 - r > SC.b;
    }
    function goneDrop(o) {
      if (!pastAll(o.SPX, o.SPY, o.nb, o.R + 2)) return false;
      var R = o.riders || [];
      for (var q = 0; q < R.length; q++) { var r = R[q]; if (!r.vis) continue; if (r.t === 'w' ? !pastAll(r.SPX, r.SPY, r.nb, r.R + 2) : !pastAll(r.X, r.Y, 1, r.r * 1.3 + 2)) return false; }
      return true;
    }
    E.frame = function (st) {
      var t = st.t, now = st.now, dt = st.dt || 0, i, o;
      if (st.wnow !== undefined) WN = st.wnow;
      if (st.scr) SC = st.scr;
      jstep(dt);
      // each piece's moments: in at ts, landed at tl (a ripple where its head comes to rest), out at xs
      var mov = false, still = true;
      for (i = 0; i < OWN.length; i++) {
        o = OWN[i];
        if (o.mode === 'wait' && t >= o.ts) o.mode = 'in';
        if (o.mode === 'in' && t >= o.tl) { o.mode = 'rest'; if (o.t === 'w') emit(o.hx, o.hy, .45 + .6 * Math.min(1, o.R / 40)); }
        if (o.mode === 'rest' && o.xs !== undefined && t >= o.xs) { o.mode = 'out'; o.tx = o.xs; o.xs = undefined; o.fly = null; if (o.t === 'u') o.up = upOf(o); }
        if (o.mode === 'wait' || o.mode === 'in' || o.mode === 'fly') still = false;
        if (o.mode === 'wait' || o.mode === 'in' || o.mode === 'out' || o.xs !== undefined || (o.mode === 'rest' && t - o.tl < 1.6)) mov = true;
        // its own slow motion fades in once it has landed, and out as it leaves
        o.ramp += ((o.mode === 'rest' && o.xs === undefined ? 1 : o.mode === 'rest' ? o.ramp : 0) - o.ramp) * (1 - Math.exp(-dt / .6));
      }
      // the slow current comes in once every piece is in
      E.gr += ((still ? 1 : 0) - E.gr) * (1 - Math.exp(-dt / .8));
      // the drop that comes at the screen: on its way until it covers the screen, or back until it lands
      var fl = E.fl;
      if (fl) { fl.done = t >= fl.t0 + fl.T; if (!fl.done || fl.kind === 'back') mov = true; if (fl.done && fl.kind === 'back') land(E.bg, t); }
      if (!E.fl) E.gz = 0;
      E.gl = null;
      E.mov = mov;
      var act = E.active();
      for (i = 0; i < P.length; i++) { o = P[i]; if (o.t === 'w' && !o.base) { if (o.mode === 'fly') placeFly(o, t, now, act); else placeDrop(o, t, now, act); } else if (o.t === 'u') placeBubble(o, t, now, act); }
      for (i = 0; i < P.length; i++) { o = P[i]; if (o.t === 'w' && o.base) placeShade(o, now, act); else if (o.t === 's') placeRider(o, now, act); }
      for (i = 0; i < P.length; i++) { o = P[i]; if (o.t === 'g') placeRider(o, now, act); }
      // a drop on its way out is gone once it and all it carries are past the screen's edge
      for (i = 0; i < DROPS.length; i++) { o = DROPS[i]; if (o.mode === 'out' && o.vis && (goneDrop(o) || t - o.tx > 5)) { goneNow(o, t); (o.riders || []).forEach(function (r) { r.vis = false; }); } }
    };
    // something on its way, or settling
    E.moving = function () { return E.mov; };
    // anything to see at rest (its slow motion), and the screen covered by the drop
    E.shown = function () { for (var i = 0; i < OWN.length; i++) if (OWN[i].vis) return true; return false; };
    E.covered = function () { return !!E.fl && E.fl.kind === 'come' && E.fl.done; };

    // ---------- drawing ----------
    function paintOf(ctx, o, gx0, gy0, gx1, gy1, flat) {
      var g = o.q.grad; if (!g) return o.q.fill;
      var gr = ctx.createLinearGradient(gx0, gy0, gx1, gy1);
      for (var k = 0; k < g.stops.length; k++) gr.addColorStop(g.stops[k][0], flat ? mixc(g.stops[k][1], o.q.fill, flat) : g.stops[k][1]);
      return gr;
    }
    function dropPath(ctx, o) { var OX = o.OX, OY = o.OY, n = OX.length; ctx.beginPath(); ctx.moveTo(OX[0], OY[0]); for (var k = 1; k < n; k++) ctx.lineTo(OX[k], OY[k]); ctx.closePath(); }
    // m: [scale, x, y] from the swirl's units to the canvas's pixels
    E.draw = function (ctx, m) {
      ctx.setTransform(m[0], 0, 0, m[0], m[1], m[2]);
      var fb = E.bg && E.bg.mode === 'fly' ? E.bg : null;
      for (var i = 0; i < P.length; i++) {
        var o = P[i]; if (!o.vis || o === fb) continue;
        var al = o.alpha; if (al <= .004) continue;
        ctx.globalAlpha = al;
        if (o.t === 'w') { dropPath(ctx, o); ctx.fillStyle = o.gp ? paintOf(ctx, o, o.GX[0], o.GY[0], o.GX[1], o.GY[1]) : o.q.fill; }
        else {
          ctx.beginPath();
          var t = o.tf, rr = o.r * (t ? t.sc : 1);
          if (t && t.st !== 1) ctx.ellipse(o.X[0], o.Y[0], rr * t.st, rr / t.st, t.dir, 0, TAU); else ctx.arc(o.X[0], o.Y[0], rr, 0, TAU);
          ctx.fillStyle = o.q.grad ? paintOf(ctx, o, o.X[1], o.Y[1], o.X[2], o.Y[2]) : o.q.fill;
        }
        ctx.fill();
      }
      ctx.globalAlpha = 1;
      // the drop that comes at the screen, over everything: its body, its head (seen head on it is round), its glint
      if (fb && fb.vis) {
        var gd = fb.gp ? Math.hypot(fb.GX[1] - fb.GX[0], fb.GY[1] - fb.GY[0]) : 0, n = fb.nb, gl = E.gl;
        ctx.fillStyle = fb.gp && fb.flat < .99 && gd > 1 ? paintOf(ctx, fb, fb.GX[0], fb.GY[0], fb.GX[1], fb.GY[1], fb.flat) : fb.q.fill;
        dropPath(ctx, fb); ctx.fill();
        var hl = fb.hull; if (hl) { ctx.beginPath(); ctx.moveTo(hl.x, hl.y); ctx.arc(fb.SPX[n - 1], fb.SPY[n - 1], fb.Rh, hl.a + hl.b, hl.a - hl.b + TAU); ctx.closePath(); ctx.fill(); }
        ctx.beginPath(); ctx.ellipse(fb.SPX[n - 1], fb.SPY[n - 1], fb.Rh * fb.sq, fb.Rh, fb.ha, 0, TAU); ctx.fill();
        if (gl) { ctx.beginPath(); ctx.ellipse(gl.x, gl.y, gl.rx, gl.ry, -.75, 0, TAU); ctx.fillStyle = GLINT; ctx.fill(); }
      }
    };
    // draws it once at rest on ctx, then the drop that comes at the screen half way and over the whole screen, and puts
    // everything back as it was (so a page can have the browser ready to draw them before they are seen)
    E.warm = function (ctx, m) {
      var keep = P.map(function (o) { return [o.mode, o.vis, o.ts, o.tl, o.ramp, o.xs, o.fly, o.after]; }), fl = E.fl, gl = E.gl, gz = E.gz;
      OWN.forEach(function (o) { o.mode = 'rest'; o.ts = o.tl = -1e9; });
      var t = 0, act = false, i, o;
      for (i = 0; i < P.length; i++) { o = P[i]; if (o.t === 'w' && !o.base) placeDrop(o, t, 0, act); else if (o.t === 'u') placeBubble(o, t, 0, act); }
      for (i = 0; i < P.length; i++) { o = P[i]; if (o.t === 'w' && o.base) placeShade(o, 0, act); else if (o.t === 's') placeRider(o, 0, act); }
      for (i = 0; i < P.length; i++) { o = P[i]; if (o.t === 'g') placeRider(o, 0, act); }
      E.fl = null; E.draw(ctx, m);
      if (E.bg) { comeAt(E.bg, 0); [.55 * TC, TC].forEach(function (tt) { placeFly(E.bg, tt, 0, false); E.draw(ctx, m); }); }
      E.fl = fl; E.gl = gl; E.gz = gz;
      P.forEach(function (o, j) { var k = keep[j]; o.mode = k[0]; o.vis = k[1]; o.ts = k[2]; o.tl = k[3]; o.ramp = k[4]; o.xs = k[5]; o.fly = k[6]; o.after = k[7]; });
    };
    // for checking: a drop's lane, where it starts and rests, its moments
    E.laneOf = function (o) { return o.lane ? { lane: o.lane, uT: o.uT, uH: o.uH, hs: o.hs, hsU: o.hsU, Din: o.Din, Dout: o.Dout, t0: o.t0, T: o.T, xo: o.xo, Tx: o.Tx } : null; };
    E.modes = function () { var c = {}; OWN.forEach(function (o) { c[o.mode] = (c[o.mode] || 0) + 1; }); return c; };
    return E;
  };
})();
